module.exports = __webpack_public_path__ + "img/icon_12.3fb2173e.png";